import React, {PropTypes} from 'react';
import {reduxForm, Field} from 'redux-form';
import {I18n} from 'react-redux-i18n';

import UserFormInput from './UserFormInput';
import UserPermissionTable from './UserPermissionTable';

const CreateUserForm = ({
  handleSubmit,
  onCancel,
  onTogglePermission,
  permissionTable,
  submitting,
  supportsCareSheet
}) => {
  return (
    <div className="container-fluid main" id="main">
      <div className="row">
        <div className="col-lg-12">
          <h1>{I18n.t('CREATE_USER')}</h1>
          <form className="user-form" onSubmit={handleSubmit}>
            <div className="row no-gutters">
              <div className="col-sm-12">
                <h5>{I18n.t('USER_INFO')}</h5>
              </div>
            </div>
            <Field name="firstName"
                   component={UserFormInput}
                   type="text"
                   label={I18n.t('FIRST_NAME')}
            />
            <Field name="lastName"
                   component={UserFormInput}
                   type="text"
                   label={I18n.t('LAST_NAME')}
            />
            <Field name="email"
                   component={UserFormInput}
                   type="text"
                   label={I18n.t('EMAIL_ADDRESS')}
            />
            <Field name="password"
                   component={UserFormInput}
                   type="password"
                   label={I18n.t('PASSWORD')}
            />
            <Field name="confirmPassword"
                   component={UserFormInput}
                   type="password"
                   label={I18n.t('CONFIRM_PASSWORD')}
            /> 
            <UserPermissionTable permissionTable={permissionTable} onTogglePermission={onTogglePermission} supportsCareSheet = {supportsCareSheet} />
            <div className="row no-gutters bottom-buttons">
              <div className="col-sm-12 text-right">
                <button type="button" className="btn btn-secondary" disabled={submitting} onClick={onCancel}>{I18n.t('CANCEL')}</button>
                <button type="submit" className="btn btn-primary" disabled={submitting}>{I18n.t('CREATE_USER')}</button> 
              </div>
            </div>
          </form> 
        </div>
      </div>
    </div>
  );
};

CreateUserForm.propTypes = {
  form: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onTogglePermission: PropTypes.func.isRequired,
  permissionTable: PropTypes.array.isRequired,
  submitFailed: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  supportsCareSheet : PropTypes.bool.isRequired,
};

export default reduxForm()(CreateUserForm);


/** WEBPACK FOOTER **
 ** ./src/modules/users/components/CreateUserForm.js
 **/